import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockReplenishmentReportData} from "./stock-replenishment-report.data";

@Injectable()
export class StockReplenishmentReportModel extends ReportModel<StockReplenishmentReportData> {
    constructor(injector: Injector) {
        super(injector, StockReplenishmentReportData);
    }
}
